/* eslint-disable react/no-unstable-nested-components */
import {
  JOIN_CHANNEL_REQUEST_LIST_ITEM_HEIGHT,
  JoinHallRequestListItem,
} from '$common/join-channel-requests/join-hall-request-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { t } from '$i18n'
import { VirtualizedInfiniteList } from '$common/virtualized-list'
import { nothing } from '$helper/functions/utils'
import { EmptySearchResult } from '$common/empty-search-result'
import { useJoinHallRequests } from '$logic/subscription/react-hook'
import { JoinHallRequestListItemSkeleton } from './join-hall-request-list-item-skeleton'
import { useRoom } from '$logic/room/react-hook'
import { ErrorStateList } from '$common/error-state-list'

type HeightFn = (itemsCount: number) => number

interface Props {
  roomId: string
  height: number | HeightFn
  searchQuery: string
}
export function JoinHallRequestList({ roomId, height, searchQuery }: Props) {
  const room = useRoom(roomId)
  const {
    loading,
    items: searchedItems,
    loadMore,
    hasMoreItemToLoad,
    hasError,
    retry,
  } = useJoinHallRequests({
    hallId: roomId,
    query: searchQuery,
  })
  const itemCount = searchedItems ? searchedItems.length : 0

  return (
    <VirtualizedInfiniteList
      items={searchedItems}
      ListItem={data => <JoinHallRequestListItem {...data} roomId={roomId} />}
      SkeletonItem={JoinHallRequestListItemSkeleton}
      height={
        typeof height === 'number' ? height : height(searchedItems.length)
      }
      overscanCount={3}
      itemSize={JOIN_CHANNEL_REQUEST_LIST_ITEM_HEIGHT}
      hasMoreItemToLoad={hasMoreItemToLoad ?? false}
      loadMore={loadMore ?? nothing}
      loading={loading}
      ErrorStateComponent={() => (
        <ErrorStateList
          text={t('JoinHallRequests.list.errorText')}
          onRetry={retry}
        />
      )}
      hasError={hasError}
      EmptyStateComponent={
        itemCount === 0
          ? EmptySearchResult
          : () => (
              <EmptyStateList
                showIcon={false}
                text={t('JoinHallRequests.list.emptyText')(room?.type)}
              />
            )
      }
    />
  )
}
